export const STANDARD_FEE = "standardFee";
export const STANDARD_COMPENSATION = "standardCompensation";
export const LEGAL_FEE = "legalFee";
export const LEGAL_COMPENSATION = "legalCompensation";
